<template>
	<div>
		<header id="header" class="header--compact">
			<router-link id="header__logo" :to="{ 'name': 'dashboard' }">
				<img src="/images/logo/logo-abstract.png" alt="Logo" width="30" />
            </router-link>
		</header>
		<main id="content" class="container">
			<div id="content__form">
				<header id="content__header">
					<slot name="header"></slot>
				</header>

				<nav id="content__nav">
					<slot name="nav"></slot>
				</nav>

				<slot></slot>
			</div>
		</main>
	</div>
</template>

<script>
	export default {
		name: 'LayoutForm',
		props: {
			breadcrumbs: {
				type: Array,
				default: () => [],
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	#content {
		padding: 9rem 7rem 3rem;
		overflow: auto;
		@include display-flex;
		@include flex-direction(column);
		@include align-items(center);

		#content__form {
			width: 45rem;
			max-width: 100%;
			padding-bottom: 4rem;
			@include flex-grow(1);
			@include display-flex;
			@include flex-direction(column);
			@include align-items(stretch);
		}

		#content__header {
			margin-bottom: 6rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;

            a {
                margin-bottom: .5rem;
            }

			> h1:last-child {
				margin-bottom: 0;
			}
		}

		#content__nav {
			margin-bottom: 4.5rem;

			&:empty {
				display: none;
			}
		}
	}
</style>

<style lang="scss">
	#content__nav .nav--steps {
		margin-left: -1.3rem;
		margin-right: -1.3rem;
	}
</style>
